<template>
  <div
    id="lista-noticias"
    class="secao-esquerda-home"
  >
    <div class="section-header">
      <h3>Notícias</h3>
      <h5>
        Fique por dentro das principais notícias da extensão da UFC
      </h5>
    </div>

    <div class="filtros-container">
      <SearchInput @pesquisar="buscar" />
      <FiltroSelect
        v-model="filtroUnidade"
        :items="unidades"
        :msg-todos="'Filtrar todas unidades'"
      />
    </div>
    <div v-if="isLoading">
      <Carregamento />
    </div>
    <div
      v-for="noticia in noticias"
      :key="noticia.id"
      v-else-if="noticias.length > 0"
    >
      <NoticiasCard :noticia="noticia" />
    </div>
    <div v-else>
      <AvisoListagem> Nenhuma notícia encontrada </AvisoListagem>
    </div>
    <BaseButton :to="'/noticias'"> Ver mais notícias </BaseButton>
  </div>
</template>

<script setup>
import { useNoticias } from "@/composables/useNoticias.js";
import SearchInput from "../layout/SearchInput.vue";
import NoticiasCard from "./NoticiasCard.vue";
import { onMounted, watch, ref } from "vue";
import BaseButton from "../common/BaseButton.vue";
import Carregamento from "../common/Carregamento.vue";
import AvisoListagem from "../common/AvisoListagem.vue";
import FiltroSelect from "../common/FiltroSelect.vue";
import { useUnidades } from "@/composables/useUnidades.js";

const { noticias, isLoading, fetchFiltrosNoticia, fetchAbrangenciaByName } =
  useNoticias();

const { unidades, fetchAllUnidades } = useUnidades();

const filtroUnidade = ref("");
const abrangenciaId = ref("");

async function buscarNoticiasPrex() {
  await fetchFiltrosNoticia({
    page: 0,
    size: 5,
    abrangenciaId: abrangenciaId.value,
  });
}

async function buscar(termoBusca) {
  await fetchFiltrosNoticia({
    page: 0,
    size: 5,
    titulo: termoBusca,
    abrangenciaId: abrangenciaId.value,
    unidadeId: filtroUnidade.value || "",
  });
}

watch(filtroUnidade, async (newValue) => {
  if (newValue !== "") {
    fetchFiltrosNoticia({ unidadeId: newValue });
  } else {
    await buscarNoticiasPrex();
  }
});

onMounted(async () => {
  abrangenciaId.value = await fetchAbrangenciaByName("prex");
  await buscarNoticiasPrex();
  await fetchAllUnidades(0, 100);
});
</script>

<style scoped>
.filtros-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;
}

.secao-esquerda-home {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgb(163, 163, 163);
  width: 100%;
}

.section-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

.section-header h5 {
  font-size: 1rem;
  font-weight: 300;
}
</style>
